var _radialGradient, _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _radialGradient2, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _path, _circle, _ellipse, _path2, _circle2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconThinking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 192.692,
    cy: 149.73,
    gradientUnits: "userSpaceOnUse",
    r: 249.815
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffce3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffae2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa425"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcee21"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 263.065,
    x2: 102.916,
    xlinkHref: "#lg1",
    y1: 226.873,
    y2: 66.724
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.877,
    x2: 227.168,
    y1: 165.302,
    y2: 43.695
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b53759"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 250.919,
    x2: 467.935,
    xlinkHref: "#lg2",
    y1: 269.752,
    y2: -133.868
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_5_",
    cx: 245.436,
    cy: 294.292,
    gradientUnits: "userSpaceOnUse",
    r: 95.801
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcee21",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3263,
    stopColor: "#fdea28",
    stopOpacity: 0.404
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7865,
    stopColor: "#fee03a",
    stopOpacity: 0.128
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffda45",
    stopOpacity: 0
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7e8595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555a66"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 172.504,
    x2: 318.367,
    xlinkHref: "#lg3",
    y1: 451.824,
    y2: 451.824
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#555a66",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555a66"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 245.319,
    x2: 245.639,
    xlinkHref: "#lg4",
    y1: 424.119,
    y2: 406.802
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 245.319,
    x2: 245.639,
    xlinkHref: "#lg4",
    y1: 460.061,
    y2: 442.743
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 245.184,
    x2: 245.504,
    xlinkHref: "#lg4",
    y1: 494.328,
    y2: 477.035
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 245.436,
    x2: 245.436,
    xlinkHref: "#lg1",
    y1: 329.729,
    y2: 279.022
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 245.436,
    x2: 245.436,
    xlinkHref: "#lg2",
    y1: 339.992,
    y2: 400.297
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 335.352,
    x2: 314.352,
    y1: 175.842,
    y2: 50.842
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2328,
    stopColor: "#e8a74b",
    stopOpacity: 0.233
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#d27751",
    stopOpacity: 0.482
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7021,
    stopColor: "#c25455",
    stopOpacity: 0.702
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8822,
    stopColor: "#b93f58",
    stopOpacity: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b53759"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 368.878,
    x2: 206.211,
    xlinkHref: "#lg2",
    y1: 405.055,
    y2: 107.055
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9f7fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0ddfc"
  }))), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 245.058,
    x2: 245.988,
    xlinkHref: "#lg5",
    y1: 389.794,
    y2: 411.666
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 245.058,
    x2: 245.988,
    xlinkHref: "#lg3",
    y1: 425.762,
    y2: 447.634
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 245.058,
    x2: 245.988,
    xlinkHref: "#lg3",
    y1: 461.73,
    y2: 483.602
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 244.758,
    x2: 248.606,
    xlinkHref: "#lg5",
    y1: 496.327,
    y2: 524.227
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cffc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a98f7"
  }))), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.076,
    x2: 55.076,
    xlinkHref: "#lg6",
    y1: 208.54,
    y2: 229.228
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 435.796,
    x2: 435.796,
    xlinkHref: "#lg6",
    y1: 208.54,
    y2: 229.228
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientTransform: "matrix(0 1 1 0 -458.347 458.347)",
    gradientUnits: "userSpaceOnUse",
    x1: -437.825,
    x2: -437.825,
    xlinkHref: "#lg6",
    y1: 701.441,
    y2: 722.129
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientTransform: "matrix(.707 .707 -.707 .707 37.527 252.847)",
    gradientUnits: "userSpaceOnUse",
    x1: -73.021,
    x2: -73.021,
    xlinkHref: "#lg6",
    y1: -179.031,
    y2: -158.342
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientTransform: "matrix(.707 -.707 -.707 -.707 37.527 -31.911)",
    gradientUnits: "userSpaceOnUse",
    x1: -215.029,
    x2: -215.029,
    xlinkHref: "#lg6",
    y1: -321.039,
    y2: -300.35
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientTransform: "matrix(-.707 -.707 .707 -.707 -610.655 -31.911)",
    gradientUnits: "userSpaceOnUse",
    x1: -967.397,
    x2: -967.397,
    xlinkHref: "#lg6",
    y1: 431.33,
    y2: 452.019
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg7"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f92814"
  }))), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 136.248,
    x2: 356.554,
    xlinkHref: "#lg7",
    y1: 209.601,
    y2: 209.601
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientTransform: "matrix(-1 0 0 -1 492.802 423.505)",
    gradientUnits: "userSpaceOnUse",
    x1: 180.8,
    x2: 312.002,
    xlinkHref: "#lg7",
    y1: 211.752,
    y2: 211.752
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 423.085,
    x2: 351.585,
    xlinkHref: "#lg2",
    y1: 306.228,
    y2: 127.228
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg8"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#92f37f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ab272"
  }))), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 333.191,
    x2: 475.446,
    xlinkHref: "#lg8",
    y1: 141.14,
    y2: 141.14
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientTransform: "matrix(-1 0 0 -1 809.84 284.832)",
    gradientUnits: "userSpaceOnUse",
    x1: 361.811,
    x2: 448.029,
    xlinkHref: "#lg8",
    y1: 142.416,
    y2: 142.416
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.349,
    x2: 363.272,
    xlinkHref: "#lg6",
    y1: 67.481,
    y2: 67.481
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientTransform: "matrix(-1 0 0 -1 619.542 135.926)",
    gradientUnits: "userSpaceOnUse",
    x1: 276.929,
    x2: 342.613,
    xlinkHref: "#lg6",
    y1: 67.963,
    y2: 67.963
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m403.318 209.244c0-88.696-73.14-160.31-162.398-157.819-84.785 2.366-152.96 72.231-153.365 157.048-.206 43.151 16.902 82.303 44.777 110.916 25.627 26.306 40.228 61.408 40.228 98.133v12.086h145.751v-12.086c0-36.549 14.284-71.671 39.871-97.769 27.919-28.474 45.136-67.479 45.136-110.509z",
    fill: "url(#SVGID_1_)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 245.436,
    cy: 209.244,
    fill: "url(#SVGID_2_)",
    r: 147.694
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 245.436,
    cy: 121.074,
    fill: "url(#SVGID_3_)",
    rx: 95.801,
    ry: 55.685
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m316.061 68.013c10.648 21.252 16.651 45.236 16.651 70.625 0 87.196-70.686 157.882-157.882 157.882-25.389 0-49.373-6.002-70.625-16.651 25.922 51.736 79.425 87.257 141.231 87.257 87.196 0 157.882-70.686 157.882-157.882 0-61.807-35.521-115.309-87.257-141.231z",
    fill: "url(#SVGID_4_)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.436,
    cy: 294.292,
    fill: "url(#SVGID_5_)",
    r: 95.801
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m302.915 496.961c-36.347 17.385-78.61 17.385-114.958 0-9.443-4.516-15.453-14.054-15.453-24.521v-78.793h145.863v78.793c0 10.467-6.01 20.005-15.452 24.521z",
    fill: "url(#SVGID_6_)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m172.504 410.617 14.462 14.462h131.401v-14.585h-145.863z",
    fill: "url(#SVGID_7_)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m172.504 446.558 14.462 14.462h131.401v-14.585h-145.863z",
    fill: "url(#SVGID_8_)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m173.806 480.703c.245.766.523 1.519.833 2.257l12.328 12.328h118.923c5.348-3.44 9.272-8.62 11.177-14.585z",
    fill: "url(#SVGID_9_)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m286.523 294.292h-2.962c-11.739 0-21.289 9.55-21.289 21.289v6.857h-16.837-16.837v-6.857c0-11.739-9.55-21.289-21.289-21.289h-2.962c-11.739 0-21.289 9.55-21.289 21.289s9.55 21.289 21.289 21.289h9.819v55.076h14.432v-55.076h16.837 16.837v55.076h14.431v-55.076h9.819c11.739 0 21.289-9.55 21.289-21.289.001-11.739-9.549-21.289-21.288-21.289zm-72.355 28.146h-9.819c-3.781 0-6.857-3.076-6.857-6.857s3.076-6.857 6.857-6.857h2.962c3.781 0 6.857 3.076 6.857 6.857zm72.355 0h-9.819v-6.857c0-3.781 3.076-6.857 6.857-6.857h2.962c3.781 0 6.857 3.076 6.857 6.857s-3.076 6.857-6.857 6.857z",
    fill: "url(#SVGID_10_)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m286.523 294.292h-2.962c-11.739 0-21.289 9.55-21.289 21.289v6.857h-16.837-16.837v-6.857c0-11.739-9.55-21.289-21.289-21.289h-2.962c-11.739 0-21.289 9.55-21.289 21.289s9.55 21.289 21.289 21.289h9.819v55.076h14.432v-55.076h16.837 16.837v55.076h14.431v-55.076h9.819c11.739 0 21.289-9.55 21.289-21.289.001-11.739-9.549-21.289-21.288-21.289zm-72.355 28.146h-9.819c-3.781 0-6.857-3.076-6.857-6.857s3.076-6.857 6.857-6.857h2.962c3.781 0 6.857 3.076 6.857 6.857zm72.355 0h-9.819v-6.857c0-3.781 3.076-6.857 6.857-6.857h2.962c3.781 0 6.857 3.076 6.857 6.857s-3.076 6.857-6.857 6.857z",
    fill: "url(#SVGID_11_)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m403.316 209.24c0 9.24-.8 18.3-2.32 27.1l-120.67-121.47-1.79-.9c-1.71-.86-2.41-2.93-1.58-4.66-.02-.04-.04-.08-.06-.12l-15.2-16.08c-1.45-.03-2.78-.94-3.26-2.39l-3.91-11.77c-.61-1.84.39-3.82 2.23-4.43l1.94-.65c1.49-.49 2.48-1.92 2.39-3.5-.2-4.16.12-8.38 1.01-12.55.08-.35.09-.71.05-1.06l-.13-.07c-1.12-.56-1.8-1.64-1.92-2.8l-1.78-.89c-.57-.29-1.02-.72-1.35-1.22 7.7.56 15.25 1.67 22.61 3.29 6.95 1.53 13.73 3.52 20.31 5.94-.33.48-.64.99-.91 1.53-2.99 5.97-.59 13.23 5.38 16.22 5.96 2.99 13.22.58 16.21-5.38.41-.82.72-1.66.93-2.51 6.2 3.41 12.15 7.23 17.81 11.42 38.83 28.76 64.01 74.92 64.01 126.95z",
    fill: "url(#SVGID_12_)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m315.536 122.96c-2.74-2.74-7.18-2.74-9.92 0l-2.89 2.88c-2.22 2.23-5.65 2.7-8.39 1.15-3.33-1.89-6.78-3.57-10.33-5.06l-18.82-18.33c-1.1-2.44-3.55-4.15-6.4-4.15h-24.77c-3.87 0-7.01 3.14-7.01 7.02v4.29c0 3.18-2.14 5.97-5.23 6.77-8.24 2.16-16.06 5.36-23.31 9.46-2.74 1.55-6.17 1.08-8.39-1.15l-2.89-2.88c-2.74-2.74-7.18-2.74-9.92 0l-17.51 17.51c-2.74 2.74-2.74 7.18 0 9.92l2.33 2.33c2.28 2.28 2.71 5.82 1.04 8.58-4.48 7.37-8 15.37-10.4 23.85-.86 3-3.61 5.06-6.73 5.06h-2.74c-3.87 0-7.01 3.14-7.01 7.01v24.77c0 2.85 1.71 5.3 4.16 6.39l13.51 13.84c2.01 6.1 4.59 11.94 7.71 17.45 1.56 2.74 1.1 6.18-1.14 8.41l-.73.74c-2.74 2.73-2.74 7.18 0 9.92l150.87 150.87h7.69v-12.09c0-36.55 14.28-71.67 39.87-97.77 27.59-28.14 44.72-66.58 45.11-109.03zm-69.13 112.93c-13.33 0-24.14-10.81-24.14-24.14s10.81-24.13 24.14-24.13 24.13 10.8 24.13 24.13-10.8 24.14-24.13 24.14z",
    fill: "url(#SVGID_13_)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m314.386 411.187h-137.901c-6.908 0-12.507-5.6-12.507-12.507 0-6.908 5.6-12.507 12.507-12.507h137.901c6.908 0 12.507 5.6 12.507 12.507 0 6.907-5.599 12.507-12.507 12.507z",
    fill: "url(#SVGID_14_)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m314.386 447.155h-137.901c-6.908 0-12.507-5.6-12.507-12.507 0-6.908 5.6-12.507 12.507-12.507h137.901c6.908 0 12.507 5.6 12.507 12.507 0 6.907-5.599 12.507-12.507 12.507z",
    fill: "url(#SVGID_15_)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m314.386 483.122h-137.901c-6.908 0-12.507-5.6-12.507-12.507 0-6.908 5.6-12.507 12.507-12.507h137.901c6.908 0 12.507 5.6 12.507 12.507 0 6.908-5.599 12.507-12.507 12.507z",
    fill: "url(#SVGID_16_)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m292.924 501.243c-13.268-4.502-29.696-7.168-47.488-7.168s-34.221 2.665-47.488 7.168c30.575 11.669 64.401 11.669 94.976 0z",
    fill: "url(#SVGID_17_)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m65.543 220.936h-20.935c-5.553 0-10.054-4.501-10.054-10.054 0-5.553 4.501-10.054 10.054-10.054h20.934c5.553 0 10.054 4.502 10.054 10.054.001 5.553-4.501 10.054-10.053 10.054z",
    fill: "url(#SVGID_18_)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m446.263 220.936h-20.934c-5.553 0-10.054-4.501-10.054-10.054 0-5.553 4.501-10.054 10.054-10.054h20.934c5.553 0 10.054 4.502 10.054 10.054 0 5.553-4.501 10.054-10.054 10.054z",
    fill: "url(#SVGID_19_)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m255.49 30.988v-20.934c0-5.552-4.501-10.054-10.054-10.054-5.553 0-10.054 4.502-10.054 10.054v20.934c0 5.553 4.501 10.054 10.054 10.054 5.553.001 10.054-4.501 10.054-10.054z",
    fill: "url(#SVGID_20_)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m111.123 90.787-14.803-14.802c-3.926-3.926-3.926-10.292 0-14.219 3.926-3.926 10.292-3.926 14.219 0l14.803 14.803c3.926 3.926 3.926 10.292 0 14.219-3.927 3.926-10.293 3.926-14.219-.001z",
    fill: "url(#SVGID_21_)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m111.123 330.976-14.803 14.803c-3.926 3.926-3.926 10.292 0 14.219 3.926 3.927 10.292 3.927 14.219 0l14.803-14.803c3.926-3.926 3.926-10.292 0-14.219-3.927-3.927-10.293-3.927-14.219 0z",
    fill: "url(#SVGID_22_)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m379.749 330.976 14.803 14.803c3.927 3.926 3.927 10.292 0 14.219-3.926 3.927-10.292 3.927-14.219 0l-14.803-14.803c-3.926-3.926-3.926-10.292 0-14.219 3.926-3.927 10.292-3.927 14.219 0z",
    fill: "url(#SVGID_23_)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m349.543 190.205h-2.739c-3.119 0-5.872-2.054-6.728-5.054-2.404-8.477-5.924-16.486-10.398-23.854-1.675-2.754-1.243-6.297 1.042-8.582l2.329-2.33c2.739-2.739 2.739-7.175 0-9.914l-17.513-17.513c-2.739-2.739-7.182-2.739-9.921 0l-2.888 2.88c-2.218 2.225-5.656 2.702-8.395 1.146-7.242-4.101-15.064-7.301-23.311-9.452-3.081-.804-5.225-3.595-5.225-6.773v-4.294c0-3.878-3.141-7.019-7.011-7.019h-24.77c-3.87 0-7.011 3.141-7.011 7.019v4.294c0 3.178-2.143 5.969-5.225 6.773-8.246 2.151-16.069 5.351-23.311 9.452-2.739 1.556-6.177 1.079-8.395-1.146l-2.888-2.88c-2.739-2.739-7.182-2.739-9.921 0l-17.513 17.513c-2.739 2.739-2.739 7.175 0 9.914l2.329 2.33c2.285 2.285 2.717 5.828 1.042 8.582-4.473 7.368-7.994 15.377-10.398 23.854-.856 2.999-3.61 5.054-6.728 5.054h-2.739c-3.87 0-7.011 3.141-7.011 7.011v24.77c0 3.878 3.141 7.011 7.011 7.011h1.608c3.252 0 6.066 2.24 6.825 5.403 2.136 8.969 5.508 17.453 9.936 25.268 1.556 2.739 1.094 6.185-1.139 8.41l-.737.744c-2.739 2.731-2.739 7.175 0 9.914l17.513 17.513c2.739 2.739 7.182 2.739 9.921 0l.179-.179c2.292-2.292 5.835-2.709 8.604-1.027 7.927 4.808 16.597 8.522 25.797 10.926 3.089.804 5.24 3.587 5.24 6.773 0 1.935.789 3.684 2.054 4.957s3.022 2.054 4.957 2.054h24.77c3.87 0 7.011-3.141 7.011-7.011 0-1.593.536-3.089 1.459-4.28s2.233-2.091 3.781-2.493c9.199-2.404 17.87-6.118 25.797-10.926 2.769-1.682 6.311-1.265 8.604 1.027l.179.179c2.739 2.739 7.182 2.739 9.921 0l17.513-17.513c2.739-2.739 2.739-7.182 0-9.914l-.737-.744c-2.233-2.225-2.694-5.671-1.139-8.41 4.428-7.815 7.8-16.3 9.936-25.268.759-3.163 3.573-5.403 6.825-5.403h1.608c3.87 0 7.011-3.133 7.011-7.011v-24.77c0-3.87-3.141-7.011-7.011-7.011zm-103.142 45.684c-13.33 0-24.137-10.807-24.137-24.137s10.807-24.137 24.137-24.137 24.137 10.807 24.137 24.137-10.807 24.137-24.137 24.137z",
    fill: "url(#SVGID_24_)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m246.401 146.152c-36.231 0-65.601 29.369-65.601 65.601s29.369 65.601 65.601 65.601 65.601-29.369 65.601-65.601-29.37-65.601-65.601-65.601zm0 89.737c-13.33 0-24.137-10.807-24.137-24.137s10.807-24.137 24.137-24.137 24.137 10.807 24.137 24.137-10.807 24.137-24.137 24.137z",
    fill: "url(#SVGID_25_)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m358.192 98.736c-1.99 2.129-3.832 4.373-5.497 6.73-1.192 1.692-3.369 2.371-5.31 1.67l-2.523-.903c-2.395-.861-5.035.384-5.896 2.779l-5.503 15.312c-.754 2.099.108 4.383 1.945 5.495.374.594 5.303 5.54 5.891 5.912-.001.008 0 .016 0 .025-.595 5.632-.444 11.377.501 17.088.331 2.022-.73 4.014-2.583 4.888l-1.628.767c-2.3 1.084-3.287 3.83-2.203 6.13l6.937 14.72c.402.852 1.032 1.521 1.781 1.974l56.603 56.603c1.707-9.301 2.609-18.885 2.609-28.68.002-43.028-17.211-82.033-45.124-110.51z",
    fill: "url(#SVGID_26_)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m460.18 100.725-1.628.767c-1.853.873-4.065.424-5.414-1.119-3.803-4.365-8.138-8.138-12.86-11.264-1.766-1.168-2.502-3.394-1.784-5.392l.732-2.037c.861-2.395-.382-5.031-2.776-5.892l-15.312-5.503c-2.395-.861-5.035.384-5.896 2.779l-.91 2.521c-.695 1.944-2.605 3.19-4.668 3.032-5.452-.409-10.997-.12-16.5.911-2.056.385-4.112-.673-5.002-2.562l-1.203-2.552c-1.086-2.304-3.832-3.291-6.132-2.207l-14.72 6.937c-2.3 1.084-3.287 3.83-2.201 6.134l1.203 2.552c.89 1.889.398 4.148-1.208 5.488-4.298 3.588-8.051 7.68-11.206 12.146-1.192 1.692-3.369 2.371-5.31 1.67l-2.523-.903c-2.395-.861-5.035.384-5.896 2.779l-5.503 15.312c-.861 2.395.382 5.031 2.776 5.892l2.037.732c1.998.718 3.247 2.702 3.023 4.808-.595 5.632-.444 11.377.502 17.088.331 2.022-.73 4.014-2.583 4.888l-1.628.767c-2.3 1.084-3.287 3.83-2.203 6.13l6.937 14.72c1.086 2.304 3.83 3.287 6.13 2.203l.955-.45c1.933-.911 4.232-.367 5.569 1.3 3.781 4.732 8.161 8.83 12.981 12.234 1.691 1.192 2.382 3.369 1.679 5.317l-.229.649c-.863 2.39.382 5.031 2.776 5.892l15.312 5.503c2.395.861 5.035-.384 5.896-2.779l.056-.156c.72-2.004 2.709-3.244 4.825-3.02 6.057.637 12.25.416 18.39-.732 2.061-.387 4.118.664 5.011 2.558.542 1.15 1.501 1.968 2.609 2.37s2.371.374 3.521-.167l14.72-6.937c2.3-1.084 3.287-3.83 2.203-6.13-.446-.947-.547-1.986-.332-2.952s.741-1.868 1.549-2.541c4.794-4.005 8.906-8.64 12.27-13.718 1.174-1.775 3.396-2.519 5.401-1.799l.156.056c2.395.861 5.035-.384 5.896-2.779l5.503-15.312c.861-2.395-.384-5.035-2.776-5.892l-.646-.236c-1.95-.697-3.189-2.616-3.032-4.679.443-5.884.07-11.871-1.172-17.799-.435-2.092.61-4.212 2.543-5.123l.955-.45c2.3-1.084 3.289-3.826 2.203-6.13l-6.937-14.72c-1.083-2.3-3.829-3.287-6.129-2.203zm-48.5 56.035c-7.922 3.733-17.371.337-21.104-7.584-3.733-7.922-.337-17.371 7.584-21.104 7.922-3.733 17.371-.338 21.104 7.584s.337 17.371-7.584 21.104z",
    fill: "url(#SVGID_27_)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m390.345 182.974c22.4 8.05 47.083-3.582 55.133-25.982s-3.582-47.083-25.982-55.133-47.083 3.582-55.133 25.982c-8.051 22.4 3.582 47.083 25.982 55.133zm19.938-55.481c8.241 2.962 12.521 12.044 9.56 20.285s-12.044 12.522-20.285 9.56-12.521-12.044-9.56-20.285 12.044-12.521 20.285-9.56z",
    fill: "url(#SVGID_28_)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m323.29 16.986-.615 1.225c-.7 1.395-2.237 2.166-3.771 1.875-4.332-.828-8.705-1.051-13.005-.705-1.608.131-3.096-.858-3.605-2.393l-.519-1.565c-.61-1.84-2.595-2.836-4.435-2.226l-11.767 3.903c-1.84.61-2.838 2.598-2.228 4.438l.64 1.939c.498 1.492-.061 3.137-1.372 4.013-3.46 2.319-6.648 5.099-9.462 8.306-1.051 1.198-2.781 1.53-4.203.817l-1.921-.964c-1.735-.871-3.845-.171-4.714 1.561l-5.561 11.08c-.869 1.731-.169 3.842 1.566 4.712l1.921.964c1.422.714 2.189 2.299 1.857 3.858-.889 4.172-1.214 8.39-1.005 12.55.081 1.575-.904 3.006-2.398 3.498l-1.937.645c-1.84.61-2.838 2.598-2.228 4.438l3.902 11.766c.61 1.84 2.595 2.836 4.435 2.226l1.565-.519c1.535-.509 3.217.093 4.073 1.461 2.292 3.655 5.084 7.028 8.336 10.007 1.15 1.056 1.45 2.749.75 4.144l-.615 1.225c-.869 1.731-.169 3.841 1.562 4.71l11.08 5.561c1.735.871 3.841.169 4.71-1.562l.361-.719c.73-1.455 2.364-2.21 3.949-1.84 4.492 1.058 9.044 1.455 13.534 1.228 1.574-.081 3.012.899 3.507 2.398l.167.497c.607 1.839 2.595 2.836 4.435 2.226l11.766-3.902c1.84-.61 2.838-2.598 2.228-4.438l-.04-.12c-.511-1.54.098-3.219 1.472-4.079 3.93-2.466 7.539-5.511 10.679-9.087 1.053-1.201 2.781-1.538 4.206-.823.866.434 1.825.474 2.679.194.853-.28 1.597-.891 2.032-1.756l5.561-11.08c.869-1.731.169-3.842-1.562-4.71-.712-.358-1.261-.933-1.587-1.613s-.434-1.468-.266-2.251c.99-4.655 1.275-9.368.904-13.993-.131-1.616.851-3.107 2.391-3.618l.12-.04c1.84-.61 2.838-2.598 2.228-4.438l-3.902-11.766c-.61-1.84-2.598-2.838-4.435-2.226l-.498.163c-1.497.499-3.142-.068-4.018-1.379-2.502-3.736-5.54-7.149-9.073-10.118-1.245-1.05-1.615-2.811-.885-4.266l.361-.719c.869-1.731.172-3.84-1.562-4.71l-11.078-5.565c-1.731-.869-3.841-.169-4.71 1.562zm-2.722 56.396c-2.993 5.963-10.254 8.371-16.217 5.378s-8.371-10.254-5.378-16.217 10.254-8.371 16.217-5.378 8.371 10.254 5.378 16.217z",
    fill: "url(#SVGID_29_)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m339.117 82.691c8.135-16.208 1.591-35.94-14.617-44.074s-35.94-1.591-44.074 14.617c-8.135 16.208-1.591 35.94 14.617 44.074s35.939 1.591 44.074-14.617zm-40.143-20.147c2.993-5.963 10.254-8.371 16.217-5.378s8.371 10.254 5.378 16.217-10.254 8.371-16.217 5.378c-5.963-2.994-8.371-10.254-5.378-16.217z",
    fill: "url(#SVGID_30_)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThinking);
export default __webpack_public_path__ + "static/media/icon-thinking.81ee514c6eb0785b424f28e179816ab0.svg";
export { ForwardRef as ReactComponent };